import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="380"
      height="326"
      fill="none"
      viewBox="0 0 380 326"
    >
      <path
        fill="#5578EC"
        d="M133 205c56.333 0 102-45.891 102-102.5C235 45.89 189.333 0 133 0S31 45.89 31 102.5C31 159.109 76.667 205 133 205Z"
        opacity={0.1}
      />
      <path
        stroke="#3351E5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M39.279 79.662a9.66 9.66 0 0 1-10.493-2.181 9.687 9.687 0 0 1-.001-13.598 9.663 9.663 0 0 1 15.804 3.062 9.691 9.691 0 0 1-2.129 10.628 9.67 9.67 0 0 1-3.181 2.09Z"
      />
      <path
        stroke="#363D49"
        strokeWidth={5}
        d="M69.02 235.193c-40.5 13.8-95.4-32.4-47.2-106 35.5-54 84.999-78.6 133.699-72.2 30.3 4 35.3 27.2 33.9 39.3"
      />
      <path
        fill="#939FB2"
        fillOpacity={0.4}
        fillRule="evenodd"
        d="M35.617 128.096c-59.6 84.5 11.7 138.1 57.3 91.7 25.4-25.8 40.4-93 46-111.6 10.5-34.9 35.4-20.3 35.9-7.6 3.6.9 10.6 1 12.9-1.3.5-6.9-.3-32.5-30.6-36.2-48.8-5.9-92 23.2-121.5 65Zm149.404-28.9c0-25.2-15.8-33-34-33.8-46.1-2.1-80.7 29.4-96.8 47.9-11.1 12.7-37.3 47.2-24.3 84.5 10.3 29.3 46.8 33.5 75.2 1.1 22.2-25.4 21.1-62.3 29.2-91.9 7.5-27.3 36.9-34.8 44-7.6l6.7-.2Z"
        clipRule="evenodd"
      />
      <path
        stroke="#363D49"
        d="M69.02 217.8c-17.4 4-32.4-4.9-39.1-20.2-13.9-31.9 12.4-70.6 23.5-83.3 16-18.4 51.099-51.2 97.099-49.1 17.6.8 33 7.9 34 31.1"
      />
      <path
        fill="#D8D8D8"
        fillRule="evenodd"
        d="M299.3 112c0-2-.4-3.9-1.1-5.7-.7-1.8-1.8-3.5-3.2-4.9-1.4-1.4-4.8-3.3-4.8-3.3-1.8-.8-3.7-1.1-5.7-1.2H106.9c-2 0-3.9.4-5.7 1.1 0 0-3.5 1.9-4.8 3.2-1.4 1.4-2.5 3-3.2 4.9-.8 2-1.2 4-1.2 5.9v119.9c0 2 .4 3.9 1.1 5.7.8 1.8 1.9 3.5 3.2 4.9 1.4 1.4 4.8 3.2 4.8 3.2 1.8.8 3.8 1.1 5.7 1.1h177.4c4 .1 7.8-1.5 10.6-4.3s4.4-6.6 4.4-10.6V112h.1Z"
        clipRule="evenodd"
      />
      <path
        fill="#EFEFEF"
        fillRule="evenodd"
        d="M93.4 120.5c-.9.9-1.4 2.1-1.4 3.3v118.4c0 1.2.5 2.4 1.4 3.3.9.9 3.3 1.4 3.3 1.4h198s2.4-.5 3.3-1.4c.9-.9 1.4-2 1.4-3.3V123.8c0-1.2-.5-2.4-1.4-3.3-.9-.9-3.3-1.3-3.3-1.3h-198s-2.5.4-3.3 1.3Z"
        clipRule="evenodd"
      />
      <path
        fill="#B5B5B6"
        fillRule="evenodd"
        d="M104.6 105.3c-.6.4-1 .9-1.3 1.5-.3.6-.4 1.3-.2 2 .1.7.4 1.3.9 1.8s1.1.8 1.7.9c.7.1 1.4.1 2-.2.6-.3 1.2-.7 1.5-1.3.4-.6.6-1.2.6-1.9h.1c0-.9-.4-1.8-1-2.4-.6-.6-1.5-1-2.4-1-.6 0-1.3.2-1.9.6Z"
        clipRule="evenodd"
      />
      <path
        fill="#D8D8D8"
        fillRule="evenodd"
        d="M107.2 148.5h80.2c1.1 0 2.2-.4 2.9-1.2.8-.8 1.2-1.8 1.2-2.9 0-1.1-.4-2.1-1.2-2.9-.8-.8-1.8-1.2-2.9-1.2h-80.2c-2.3 0-4.1 1.8-4.1 4.1 0 2.2 1.8 4.1 4.1 4.1Zm0 19.5h80.2c1.1 0 2.2-.4 2.9-1.2.8-.8 1.2-1.8 1.2-2.9 0-1.1-.4-2.1-1.2-2.9-.8-.8-1.8-1.2-2.9-1.2h-80.2c-2.3 0-4.1 1.8-4.1 4.1 0 2.2 1.8 4.1 4.1 4.1Zm0 19.5h80.2c1.1 0 2.2-.4 2.9-1.2.8-.8 1.2-1.8 1.2-2.9 0-1.1-.4-2.1-1.2-2.9-.8-.8-1.8-1.2-2.9-1.2h-80.2c-2.3 0-4.1 1.8-4.1 4.1 0 2.2 1.8 4.1 4.1 4.1Z"
        clipRule="evenodd"
      />
      <path
        fill="#B5B5B6"
        fillRule="evenodd"
        d="M116 108.8c.1.6.5 1.3.9 1.7.5.5 1.1.8 1.7.9.7.1 1.3.1 2-.2.6-.3 1.1-.7 1.5-1.3.4-.6.6-1.2.6-1.9 0-.9-.4-1.8-1-2.4-.6-.6-1.5-1-2.4-1-.7 0-1.3.2-1.9.6-.6.4-1 .9-1.2 1.5-.3.8-.4 1.5-.2 2.1Zm15.5 2.7c.7.1 1.3.1 2-.2.7-.3 1.1-.7 1.5-1.3.4-.6.6-1.2.6-1.9 0-.9-.4-1.8-1-2.4-.6-.6-1.5-1-2.4-1-.7 0-1.3.2-1.9.6-.6.4-1 .9-1.2 1.5-.3.6-.3 1.3-.2 2 .1.6.5 1.3.9 1.7.4.5 1 .8 1.7 1Z"
        clipRule="evenodd"
      />
      <path
        fill="#D8D8D8"
        fillRule="evenodd"
        d="M238.298 145.699c0-1.5-1.2-2.8-2.8-2.8-1.5 0-2.8 1.2-2.8 2.8 0 1.5 1.2 2.8 2.8 2.8 1.6 0 2.8-1.3 2.8-2.8Z"
        clipRule="evenodd"
      />
      <path
        stroke="#979797"
        d="M238.298 145.699c0-1.5-1.2-2.8-2.8-2.8-1.5 0-2.8 1.2-2.8 2.8 0 1.5 1.2 2.8 2.8 2.8 1.6 0 2.8-1.3 2.8-2.8Z"
      />
      <path
        fill="#13CB75"
        fillRule="evenodd"
        stroke="#28282D"
        strokeMiterlimit={10}
        d="m308.998 204.899-1.3-13s-3.2-23.7-16.6-34.7c-21.9-16.2-55.8-24.6-55.8-24.6l-30.5 3.3s-57.4 6.5-60.8 35.6c-1.6 14-13.5 24.2-20.6 33.5-2.7 3.6-9.9 15.9-9.9 15.9h8.2l187.3-16Z"
        clipRule="evenodd"
      />
      <path
        stroke="#000"
        strokeWidth={1.5}
        d="m308.998 204.899-1.3-13s-3.2-23.7-16.6-34.7c-21.9-16.2-55.8-24.6-55.8-24.6l-30.5 3.3s-57.4 6.5-60.8 35.6c-1.6 14-13.5 24.2-20.6 33.5-2.7 3.6-9.9 15.9-9.9 15.9h8.2l187.3-16Z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M136.398 290.499h161c3.9 0 7-3.1 7-7v-101.5c0-3.9-3.1-7-7-7h-161c-3.9 0-7 3.1-7 7v101.5c0 3.9 3.1 7 7 7Z"
        clipRule="evenodd"
      />
      <path
        stroke="#000"
        strokeWidth={1.5}
        d="M136.398 290.499h161c3.9 0 7-3.1 7-7v-101.5c0-3.9-3.1-7-7-7h-161c-3.9 0-7 3.1-7 7v101.5c0 3.9 3.1 7 7 7Z"
      />
      <path
        fill="#EFEFEF"
        fillRule="evenodd"
        d="M140.998 280.699h151.8v-96h-151.8v96Z"
        clipRule="evenodd"
      />
      <path
        stroke="#000"
        strokeWidth={1.5}
        d="M140.998 280.699h151.8v-96h-151.8v96Z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m135.998 242.799 21.3-3.1s1.9-.5 1.9-2.7c0-2.3-1.9-2.4-1.9-2.4l-21.3 1.2 23.3-4.5s1.6-1.4 1.2-3.8c-.4-2.5-4.1-2-4.1-2l-21.4 2 22.3-3.8s1.7-.3 1.9-2.3c.1-1.9-1.9-2.5-1.9-2.5h-27.9v-8.1s-19.5 6.4-19.5 19.9c0 13.4 12.8 17.5 21.5 17.5 8.8 0 19.9-.6 22.1-2.2 2.2-1.6.7-3.9.7-3.9l-18.2.7Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        stroke="#28282D"
        strokeMiterlimit={10}
        strokeWidth={1.4}
        d="m135.998 242.799 21.3-3.1s1.9-.5 1.9-2.7c0-2.3-1.9-2.4-1.9-2.4l-21.3 1.2 23.3-4.5s1.6-1.4 1.2-3.8c-.4-2.5-4.1-2-4.1-2l-21.4 2 22.3-3.8s1.7-.3 1.9-2.3c.1-1.9-1.9-2.5-1.9-2.5h-27.9v-8.1s-19.5 6.4-19.5 19.9c0 13.4 12.8 17.5 21.5 17.5 8.8 0 19.9-.6 22.1-2.2 2.2-1.6.7-3.9.7-3.9l-18.2.7Z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M290.398 211.399c-3.1 1-.8 12.2-.8 12.2s5.1 21.8 18.6 22.5c13.4.7 18.1-11.8 18.6-20.6s.5-19.9-1-22.2c-1.5-2.3-3.9-.9-3.9-.9l-.1 18.3-2-21.5s-.4-1.9-2.6-2c-2.3-.1-2.5 1.7-2.5 1.7l.1 21.4-3.3-23.5s-1.3-1.6-3.8-1.4c-2.5.3-2.2 4-2.2 4l.9 21.5-2.7-22.4s-.2-1.7-2.2-2c-1.9-.2-2.6 1.7-2.6 1.7l-1.6 26c-.1 0-3.8-13.7-6.9-12.8Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        stroke="#28282D"
        strokeMiterlimit={10}
        strokeWidth={1.4}
        d="M290.398 211.399c-3.1 1-.8 12.2-.8 12.2s5.1 21.8 18.6 22.5c13.4.7 18.1-11.8 18.6-20.6s.5-19.9-1-22.2c-1.5-2.3-3.9-.9-3.9-.9l-.1 18.3-2-21.5s-.4-1.9-2.6-2c-2.3-.1-2.5 1.7-2.5 1.7l.1 21.4-3.3-23.5s-1.3-1.6-3.8-1.4c-2.5.3-2.2 4-2.2 4l.9 21.5-2.7-22.4s-.2-1.7-2.2-2c-1.9-.2-2.6 1.7-2.6 1.7l-1.6 26c-.1 0-3.8-13.7-6.9-12.8Z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M279.753 123.224c0-2.648-2.229-4.877-4.877-4.877-2.647 0-4.876 2.229-4.876 4.877 0 2.647 2.229 4.876 4.876 4.876 2.648 0 4.877-2.229 4.877-4.876Z"
        clipRule="evenodd"
      />
      <path
        stroke="#A3A3A3"
        strokeWidth={1.393}
        d="M279.753 123.224c0-2.648-2.229-4.877-4.877-4.877-2.647 0-4.876 2.229-4.876 4.877 0 2.647 2.229 4.876 4.876 4.876 2.648 0 4.877-2.229 4.877-4.876Z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M307.758 112.216c0-5.712-4.737-10.449-10.45-10.449-5.712 0-10.449 4.737-10.449 10.449 0 5.713 4.737 10.45 10.449 10.45 5.713 0 10.45-4.598 10.45-10.45Z"
        clipRule="evenodd"
      />
      <path
        stroke="#A3A3A3"
        strokeWidth={1.393}
        d="M307.758 112.216c0-5.712-4.737-10.449-10.45-10.449-5.712 0-10.449 4.737-10.449 10.449 0 5.713 4.737 10.45 10.449 10.45 5.713 0 10.45-4.598 10.45-10.45Z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M337.574 115.978h18.113c6.13 0 11.982-2.368 16.301-6.687 4.319-4.32 6.688-10.171 6.688-16.302 0-6.13-2.369-11.982-6.688-16.301-4.319-4.32-10.171-6.688-16.301-6.688h-18.113c-6.13 0-11.982 2.369-16.301 6.688-4.319 4.319-6.688 10.17-6.688 16.301 0 6.13 2.369 11.982 6.688 16.302 4.319 4.319 10.171 6.687 16.301 6.687Z"
        clipRule="evenodd"
      />
      <path
        stroke="#A3A3A3"
        strokeWidth={1.393}
        d="M337.574 115.978h18.113c6.13 0 11.982-2.368 16.301-6.687 4.319-4.32 6.688-10.171 6.688-16.302 0-6.13-2.369-11.982-6.688-16.301-4.319-4.32-10.171-6.688-16.301-6.688h-18.113c-6.13 0-11.982 2.369-16.301 6.688-4.319 4.319-6.688 10.17-6.688 16.301 0 6.13 2.369 11.982 6.688 16.302 4.319 4.319 10.171 6.687 16.301 6.687Z"
      />
      <path
        fill="#A3A3A3"
        fillRule="evenodd"
        d="m333.568 97.056 2.23 2.23-1.533 1.532-2.229-2.229c-.14-.14-.279-.14-.418 0l-1.394 1.393c-.139.14-.139.279 0 .418l2.23 2.23-2.23 2.229v.418l1.533 1.532h.418l8.778-8.777a10.616 10.616 0 0 0 6.548 2.229 10.584 10.584 0 0 0 10.589-10.589c0-5.852-4.876-10.728-10.728-10.728a10.584 10.584 0 0 0-10.589 10.589c0 2.508.836 4.737 2.229 6.548l-1.393 1.394-2.09-2.23c-.139-.14-.279-.14-.418 0l-1.393 1.393c-.14.14-.14.28-.14.418Zm21.736-7.523c0-2.09-.836-4.18-2.369-5.573-1.533-1.533-3.483-2.369-5.573-2.369-2.09 0-4.18.836-5.573 2.369-1.533 1.532-2.369 3.483-2.369 5.573 0 2.09.836 4.18 2.369 5.573 1.532 1.532 3.483 2.369 5.573 2.369 2.09 0 4.18-.837 5.573-2.37 1.393-1.532 2.369-3.482 2.369-5.572Z"
        clipRule="evenodd"
      />
      <path
        stroke="#A3A3A3"
        strokeWidth={2.09}
        d="m357.916 103.021 2.647 3.344 5.295-5.852"
      />
      <path
        fill="#fff"
        d="M192.534 102.781c-3.028 0-8.534-2.753-8.534-10.049 0-3.579 2.065-5.919 5.368-6.607m54.098 16.656c3.028 0 8.534-2.753 8.534-10.049 0-3.579-2.202-5.919-5.506-6.607"
      />
      <path
        stroke="#0A0B1F"
        d="M192.534 102.781c-3.028 0-8.534-2.753-8.534-10.049 0-3.579 2.065-5.919 5.368-6.607m54.098 16.656c3.028 0 8.534-2.753 8.534-10.049 0-3.579-2.202-5.919-5.506-6.607"
      />
      <path
        fill="#000"
        fillRule="evenodd"
        d="M242.503 63.543c7.02 0 9.773 9.91 3.166 23.951L217.735 74.03l-1.136 13.748h-26.133c-3.154-11.928-.183-22.484 1.337-26.24-.839-.385-4.341-2.163-5.187-5.427 7.984 1.652 11.976-.138 11.976-.138s-3.579-3.717-3.304-6.607c5.604 2.712 11.624.971 17.942-.855 3.304-.955 6.689-1.933 10.139-2.311 10.186-1.24 22.024 3.166 19.134 17.344Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        stroke="#28282D"
        strokeMiterlimit={10}
        d="M201.069 119.161v16.931c0 16.519 34 17.344 34 0v-16.518l-34-.413Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        stroke="#28282D"
        strokeMiterlimit={10}
        d="M243.741 80.619s-8.259-5.231-10.737-9.223c-3.579 1.376-14.454 1.652-14.454 1.652s-13.214-1.652-15.141-1.652c-2.34 5.093-10.599 9.223-10.599 9.223v18.583c0 4.68 5.23 26.979 25.603 26.979 20.372 0 25.19-22.85 25.19-26.842 0-3.992.138-18.72.138-18.72Z"
        clipRule="evenodd"
      />
      <path
        stroke="#0A0B1F"
        strokeMiterlimit={10}
        strokeWidth={1.4}
        d="M216.222 85.58s1.906 13.202-1.344 16.717c-.203.219-.25.531-.078.766.594.859 2.172 2.593 4.718 1.64M212.5 115.5s3.309-.295 11.764-1.797"
      />
      <path
        fill="#0A0B1F"
        d="M204.082 91.5a1.947 1.947 0 0 1-1.937-1.936c0-1.063.875-1.938 1.937-1.938s1.937.875 1.937 1.938a1.947 1.947 0 0 1-1.937 1.937ZM228.393 91.5a1.947 1.947 0 0 1-1.937-1.936c0-1.063.875-1.938 1.937-1.938s1.937.875 1.937 1.938a1.947 1.947 0 0 1-1.937 1.937Z"
      />
      <path
        stroke="#000"
        strokeWidth={1.5}
        d="m148.4 283-3.4 4.6m7.8-4.6-3.4 4.6m9.4-4.6-3.4 4.6m6.8-4.6-3.4 4.6"
      />
      <path
        stroke="#5578EC"
        strokeWidth={1.944}
        d="M101.439 268.8c1.1.6 2.4.8 3.6.5.9-.2 1.7-.7 2.3-1.4.6-.7 1-1.6 1.1-2.5.1-.9 0-1.9-.4-2.7-.4-.8-1.1-1.5-1.9-2-.8-.5-1.7-.7-2.7-.6-.9.1-1.8.4-2.6 1-.7.6-1.3 1.4-1.6 2.2-.3.9-.3 1.8-.1 2.7.5 1.2 1.2 2.2 2.3 2.8Z"
      />
      <path
        fill="#5578EC"
        fillRule="evenodd"
        d="M173.256 184.383v51.9s2 8.9 10.4 17.2c6.5 6.4 21.9 14.5 28.7 18.1 1.1.6 2 1 2 1l2 1c.5.3 1.5.3 2 0l2-1c4-1.9 22.3-11.7 29.7-19.1 8.4-8.3 10.4-17.2 10.4-17.2v-51.9c0-1.6-1-3.1-2.6-3.5l-41-13.1-41 13.1c-1.6.4-2.6 1.9-2.6 3.5Z"
        clipRule="evenodd"
      />
      <path
        stroke="#3351E5"
        strokeWidth={9}
        d="M173.256 184.383v51.9s2 8.9 10.4 17.2c6.5 6.4 21.9 14.5 28.7 18.1 1.1.6 2 1 2 1l2 1c.5.3 1.5.3 2 0l2-1c4-1.9 22.3-11.7 29.7-19.1 8.4-8.3 10.4-17.2 10.4-17.2v-51.9c0-1.6-1-3.1-2.6-3.5l-41-13.1-41 13.1c-1.6.4-2.6 1.9-2.6 3.5Z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M210.556 219.583c.7.3 1.4.6 2.2.8v24.3c0 2.2 1.8 3.9 3.9 3.9 2.2 0 3.9-1.8 3.9-3.9v-9.3h6.7c2.2 0 3.9-1.8 3.9-4.1 0-2.2-1.8-3.9-3.9-3.9h-6.6v-6.9c5.8-1.6 10-7.2 10.2-13.2v-.5c-.1-2.7-.9-5.5-2.4-7.7-1.8-2.5-4.2-4.3-7.1-5.4-5.3-1.9-11.7-.1-15.2 4.1-2 2.5-3.2 5.2-3.4 8.4-.2 2.8.5 5.7 2 8.1 1.3 2.2 3.4 4.2 5.8 5.3Z"
        clipRule="evenodd"
      />
      <path
        fill="#5578EC"
        fillRule="evenodd"
        d="M211.255 209.283c.2.3.3.6.5.9.1 0 .1.2.3.4.1.2.3.3.5.5l.6.6.1.1c.3.2.7.4 1.1.6.5.2 1 .3 1.5.4h1.6c.5-.1 1-.2 1.5-.4.3-.2.6-.3.9-.5 0 0 .2-.1.4-.3.2-.1.3-.3.5-.5l.6-.6.1-.1c.2-.4.5-.7.6-1.1.2-.5.3-1 .4-1.5v-1.6c-.1-.5-.2-1-.4-1.5-.2-.3-.3-.6-.5-.9 0 0-.1-.2-.3-.4-.1-.2-.3-.3-.5-.5l-.6-.6-.1-.1c-.4-.2-.7-.5-1.1-.6-.5-.2-1-.3-1.5-.4h-1.6c-.5.1-1 .2-1.5.4-.3.2-.6.3-.9.5 0 0-.2.1-.4.3l-.5.5-.6.6-.1.1c-.2.4-.5.7-.6 1.1-.2.5-.3 1-.4 1.5v1.6c.1.5.2 1 .4 1.5Z"
        clipRule="evenodd"
      />
      <path
        fill="#939FB2"
        fillOpacity={0.4}
        d="M345.496 278.754s9.243 28.311-25.314 46.336c0 0-4.097 1.55-2.348-4.573 1.748-6.135 23.278-2.848 25.469-36.381 0 0-.715-7.577 2.193-5.382ZM332.195 278.387s6.376 19.548-17.482 32.003c0 0-2.833 1.07-1.618-3.16 1.204-4.228 16.067-1.965 17.587-25.123 0 0-.501-5.235 1.513-3.72Z"
      />
    </svg>
  );
}

export default Icon;
